/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<g opacity="0.4">
				<path
					d="M11 20C11 21.1046 10.1046 22 9 22C7.89543 22 7 21.1046 7 20C7 18.8954 7.89543 18 9 18C10.1046 18 11 18.8954 11 20Z"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M21 20C21 21.1046 20.1046 22 19 22C17.8954 22 17 21.1046 17 20C17 18.8954 17.8954 18 19 18C20.1046 18 21 18.8954 21 20Z"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M10 8.2C10 7.07989 10 6.51984 10.218 6.09202C10.4097 5.71569 10.7157 5.40973 11.092 5.21799C11.5198 5 12.0799 5 13.2 5H16.8C17.9201 5 18.4802 5 18.908 5.21799C19.2843 5.40973 19.5903 5.71569 19.782 6.09202C20 6.51984 20 7.07989 20 8.2V11.8C20 12.9201 20 13.4802 19.782 13.908C19.5903 14.2843 19.2843 14.5903 18.908 14.782C18.4802 15 17.9201 15 16.8 15H13.2C12.0799 15 11.5198 15 11.092 14.782C10.7157 14.5903 10.4097 14.2843 10.218 13.908C10 13.4802 10 12.9201 10 11.8V8.2Z"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<path
				d="M22 15L10.163 15C8.68692 15.0001 7.94886 15.0001 7.35491 14.7286C6.83149 14.4894 6.38793 14.1047 6.0771 13.6204C5.72439 13.0708 5.62001 12.3401 5.41126 10.8789L4.35355 3.47493C4.15068 2.05485 2.9345 1.00004 1.5 1V1L1 1.00006"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="10"
				y="5"
				width="10"
				height="10"
				rx="3"
				fill="currentColor"
			/>
			<path
				d="M22 15L10.163 15C8.68692 15.0001 7.94886 15.0001 7.35491 14.7286C6.83149 14.4894 6.38793 14.1047 6.0771 13.6204C5.72439 13.0708 5.62001 12.3401 5.41126 10.8789L4.35355 3.47493C4.15068 2.05485 2.9345 1.00004 1.5 1V1L1 1.00006M11 20C11 21.1046 10.1046 22 9 22C7.89543 22 7 21.1046 7 20C7 18.8954 7.89543 18 9 18C10.1046 18 11 18.8954 11 20ZM21 20C21 21.1046 20.1046 22 19 22C17.8954 22 17 21.1046 17 20C17 18.8954 17.8954 18 19 18C20.1046 18 21 18.8954 21 20ZM14.8 15H15.2C16.8802 15 17.7202 15 18.362 14.673C18.9265 14.3854 19.3854 13.9265 19.673 13.362C20 12.7202 20 11.8802 20 10.2V9.8C20 8.11984 20 7.27976 19.673 6.63803C19.3854 6.07354 18.9265 5.6146 18.362 5.32698C17.7202 5 16.8802 5 15.2 5H14.8C13.1198 5 12.2798 5 11.638 5.32698C11.0735 5.6146 10.6146 6.07354 10.327 6.63803C10 7.27976 10 8.11984 10 9.8V10.2C10 11.8802 10 12.7202 10.327 13.362C10.6146 13.9265 11.0735 14.3854 11.638 14.673C12.2798 15 13.1198 15 14.8 15Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.49991 0.25L0.999908 0.250061C0.585695 0.250112 0.249949 0.585939 0.25 1.00015C0.250051 1.41437 0.585878 1.75011 1.00009 1.75006L1.49998 1.75H1.50006H1.50009C2.56131 1.75008 3.46101 2.53043 3.61109 3.581L4.6688 10.9849L4.67297 11.0141L4.67297 11.0141C4.7738 11.72 4.85547 12.2918 4.95799 12.7539C5.06396 13.2316 5.20294 13.6469 5.44591 14.0255C5.83444 14.6309 6.3889 15.1117 7.04316 15.4108C7.4523 15.5977 7.88305 15.6766 8.37092 15.7139C8.84292 15.7501 9.42047 15.7501 10.1335 15.75H10.1335H10.163L15.95 15.75H22C22.4142 15.75 22.75 15.4142 22.75 15C22.75 14.5858 22.4142 14.25 22 14.25L20.3481 14.25C20.3742 14.2047 20.3992 14.1587 20.423 14.112C20.75 13.4702 20.75 12.6302 20.75 10.95V9.05C20.75 7.36984 20.75 6.52976 20.423 5.88803C20.1354 5.32354 19.6765 4.8646 19.112 4.57698C18.4702 4.25 17.6302 4.25 15.95 4.25H14.05C12.3698 4.25 11.5298 4.25 10.888 4.57698C10.3235 4.8646 9.8646 5.32354 9.57698 5.88803C9.25 6.52976 9.25 7.36984 9.25 9.05V10.95C9.25 12.6302 9.25 13.4702 9.57698 14.112C9.60071 14.1585 9.62561 14.2044 9.65164 14.2495C9.16537 14.248 8.79345 14.2419 8.4854 14.2183C8.08672 14.1878 7.85146 14.1309 7.66665 14.0465C7.27409 13.8671 6.94142 13.5785 6.7083 13.2153C6.59855 13.0443 6.50899 12.8194 6.4224 12.4291C6.33377 12.0296 6.25972 11.5148 6.15372 10.7728L5.09601 3.36887C4.84036 1.57931 3.30775 0.250044 1.50002 0.25L1.5 1L1.49991 0.25ZM9 17.25C7.48122 17.25 6.25 18.4812 6.25 20C6.25 21.5188 7.48122 22.75 9 22.75C10.5188 22.75 11.75 21.5188 11.75 20C11.75 18.4812 10.5188 17.25 9 17.25ZM19 17.25C17.4812 17.25 16.25 18.4812 16.25 20C16.25 21.5188 17.4812 22.75 19 22.75C20.5188 22.75 21.75 21.5188 21.75 20C21.75 18.4812 20.5188 17.25 19 17.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 15L10.163 15C8.68692 15.0001 7.94886 15.0001 7.35491 14.7286C6.83149 14.4894 6.38793 14.1047 6.0771 13.6204C5.72439 13.0708 5.62001 12.3401 5.41126 10.8789L4.35355 3.47493C4.15068 2.05485 2.9345 1.00004 1.5 1V1L1 1.00006M17 20C17 21.1046 17.8954 22 19 22C20.1046 22 21 21.1046 21 20C21 18.8954 20.1046 18 19 18M20 12V9.8C20 8.11984 20 7.27976 19.673 6.63803C19.3854 6.07354 18.9265 5.6146 18.362 5.32698C17.7202 5 16.8802 5 15.2 5H14.8C13.1198 5 12.2798 5 11.638 5.32698C11.0735 5.6146 10.6146 6.07354 10.327 6.63803C10 7.27976 10 8.11984 10 9.8V10.2C10 11.8802 10 12.7202 10.327 13.362C10.6146 13.9265 11.0735 14.3854 11.638 14.673C12.2798 15 13.1198 15 14.8 15H15M11 20C11 21.1046 10.1046 22 9 22C7.89543 22 7 21.1046 7 20C7 18.8954 7.89543 18 9 18C10.1046 18 11 18.8954 11 20Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M22 15L10.163 15C8.68692 15.0001 7.94886 15.0001 7.35491 14.7286C6.83149 14.4894 6.38793 14.1047 6.0771 13.6204C5.72439 13.0708 5.62001 12.3401 5.41126 10.8789L4.35355 3.47493C4.15068 2.05485 2.9345 1.00004 1.5 1V1L1 1.00006M11 20C11 21.1046 10.1046 22 9 22C7.89543 22 7 21.1046 7 20C7 18.8954 7.89543 18 9 18C10.1046 18 11 18.8954 11 20ZM21 20C21 21.1046 20.1046 22 19 22C17.8954 22 17 21.1046 17 20C17 18.8954 17.8954 18 19 18C20.1046 18 21 18.8954 21 20ZM14.8 15H15.2C16.8802 15 17.7202 15 18.362 14.673C18.9265 14.3854 19.3854 13.9265 19.673 13.362C20 12.7202 20 11.8802 20 10.2V9.8C20 8.11984 20 7.27976 19.673 6.63803C19.3854 6.07354 18.9265 5.6146 18.362 5.32698C17.7202 5 16.8802 5 15.2 5H14.8C13.1198 5 12.2798 5 11.638 5.32698C11.0735 5.6146 10.6146 6.07354 10.327 6.63803C10 7.27976 10 8.11984 10 9.8V10.2C10 11.8802 10 12.7202 10.327 13.362C10.6146 13.9265 11.0735 14.3854 11.638 14.673C12.2798 15 13.1198 15 14.8 15Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M14.05 4.25C12.3698 4.25 11.5298 4.25 10.888 4.57698C10.3235 4.8646 9.8646 5.32354 9.57698 5.88803C9.25 6.52976 9.25 7.36984 9.25 9.05V10.95C9.25 12.6302 9.25 13.4702 9.57698 14.112C9.8646 14.6765 10.3235 15.1354 10.888 15.423C11.5298 15.75 12.3698 15.75 14.05 15.75H15.95C17.6302 15.75 18.4702 15.75 19.112 15.423C19.6765 15.1354 20.1354 14.6765 20.423 14.112C20.75 13.4702 20.75 12.6302 20.75 10.95V9.05C20.75 7.36984 20.75 6.52976 20.423 5.88803C20.1354 5.32354 19.6765 4.8646 19.112 4.57698C18.4702 4.25 17.6302 4.25 15.95 4.25H14.05Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.49991 0.25L0.999908 0.250061C0.585695 0.250112 0.249949 0.585939 0.25 1.00015C0.250051 1.41437 0.585878 1.75011 1.00009 1.75006L1.49998 1.75H1.50006H1.50009C2.56131 1.75008 3.46101 2.53043 3.61109 3.581L4.6688 10.9849L4.67297 11.0141L4.67297 11.0141C4.7738 11.72 4.85547 12.2918 4.95799 12.7539C5.06396 13.2316 5.20294 13.6469 5.44591 14.0255C5.83444 14.6309 6.3889 15.1117 7.04316 15.4108C7.4523 15.5977 7.88305 15.6766 8.37092 15.7139C8.84292 15.7501 9.42047 15.7501 10.1335 15.75H10.1335H10.163L22 15.75C22.4142 15.75 22.75 15.4142 22.75 15C22.75 14.5858 22.4142 14.25 22 14.25L10.163 14.25C9.41354 14.25 8.89344 14.2495 8.4854 14.2183C8.08672 14.1878 7.85146 14.1309 7.66665 14.0465C7.27409 13.8671 6.94142 13.5785 6.7083 13.2153C6.59855 13.0443 6.50899 12.8194 6.4224 12.4291C6.33377 12.0296 6.25972 11.5148 6.15372 10.7728L5.09601 3.36887C4.84036 1.57931 3.30775 0.250044 1.50002 0.25L1.5 1L1.49991 0.25ZM6.25 20C6.25 18.4812 7.48122 17.25 9 17.25C10.5188 17.25 11.75 18.4812 11.75 20C11.75 21.5188 10.5188 22.75 9 22.75C7.48122 22.75 6.25 21.5188 6.25 20ZM16.25 20C16.25 18.4812 17.4812 17.25 19 17.25C20.5188 17.25 21.75 18.4812 21.75 20C21.75 21.5188 20.5188 22.75 19 22.75C17.4812 22.75 16.25 21.5188 16.25 20Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
